import box from "./styles/box";
import creative from "./styles/creative";
import docbox from "./styles/docbox";
import light from "./styles/light";
import topicsbox from "./styles/topicsbox";
import { useSelect } from '@wordpress/data';

const SinglePreset = ({ attributes, articlesNumber }) => {
    const { docSinglePreset, parentTitle, docId, sectionsNumber, parent_docs_order, orderBy } = attributes;

    // Mapping presets to components
    const presetComponents = {
        box: box,
        creative: creative,
        docbox: docbox,
        light: light,
        topicsbox: topicsbox,
    };

    // Fallback to StyleOne if docSinglePreset is not found in the mapping
    const Preset = presetComponents[docSinglePreset] || light;
    
    
    // sections title post
    const docSections = useSelect((select) => {
        return select('core').getEntityRecords('postType', 'docs', {
            per_page: sectionsNumber,
            order: parent_docs_order,
            orderby : orderBy,
            parent: docId,
            status: ['publish', 'private']
        });
    }, [docId, sectionsNumber, parent_docs_order, orderBy]);

    return (
        <Preset
            attributes={attributes}
            docSections={docSections}
            articlesNumber={articlesNumber}
        />
    );
};

export default SinglePreset;
